<template>
  <div class="segment-wrap">
    <div class="segment-control">
      <div class="horiz" :style="horizStyle"></div>
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        type="button"
        class="segment-btn"
        :class="{ on: currentTab === tab.value }"
        ref="btnRefs"
        @click="selectTab(index, tab.value)"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
  <div class="card-con" :class="{ open: currentTab === 'korea' }">
    <!-- 등록카드 없을때 -->
    <div class="before-regist" style="display: none">
      <div class="txt-wrap">
        <h1 class="app-tit">{{ t('ss_no_card_registered') }}</h1>
        <span class="sub-txt">{{ t('ss_card_required_for_payment') }}</span>
      </div>
      <button type="button" class="card-add-btn">
        <img :src="'/images/mobile/icon/add-icon.svg'" alt="" />
      </button>
    </div>

    <!-- 등록카드 있을때 -->
    <div class="after-regist">
      <div class="badge-pst">
        <span class="badge3 success-bg">{{ t('ss_payment_card') }}</span>
      </div>
      <div class="card-info-wrap">
        <img :src="'/images/mobile/visual/card.svg'" alt="" />
        <p class="card-name">현대카드</p>
        <span class="card-num">40457700****123*</span>
      </div>
      <RouterLink to="/app/payment" class="gray-btn l-btn">
        <span>{{ t('ss_register_new_korean_card') }}</span>
      </RouterLink>
    </div>
  </div>
  <div class="card-con" :class="{ open: currentTab === 'oversea' }">
    <!-- 등록카드 없을때 -->
    <div class="before-regist" style="display: none">
      <div class="txt-wrap">
        <h1 class="app-tit">{{ t('ss_register_foreign_card_change') }}</h1>
        <span class="sub-txt"
          >{{ t('ss_currently_paying_domestic') }}<br />
          {{ t('ss_register_foreign_card_guide') }}</span
        >
      </div>
      <button type="button" class="card-add-btn">
        <img :src="'/images/mobile/icon/add-icon.svg'" alt="" />
      </button>
    </div>

    <!-- 등록카드 있을때 -->
    <div class="after-regist">
      <div class="card-info-wrap">
        <img :src="'/images/mobile/visual/card.svg'" alt="" />
        <p class="card-name">{{ t('ss_label_foreign_card') }}</p>
        <span class="card-num">40457700****123*</span>
      </div>
      <RouterLink to="/app/payment" class="gray-btn l-btn">
        <span>{{ t('ss_pay_with_this_card') }}</span>
      </RouterLink>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const currentTab = ref('korea');
const tabs = computed(() => [
  { label: t('ss_label_korean_card'), value: 'korea' },
  { label: t('ss_label_foreign_card'), value: 'oversea' },
]);

const btnRefs = ref([]);

const horizStyle = ref({
  width: '0px',
  left: '0px',
});

// 위치 계산 및 이동 함수
const moveHoriz = (index) => {
  const btn = btnRefs.value[index];
  if (!btn) return;

  horizStyle.value = {
    width: `${btn.offsetWidth}px`,
    left: `${btn.offsetLeft}px`,
  };
};

// 탭 선택 핸들러
const selectTab = (index, value) => {
  currentTab.value = value;
  moveHoriz(index);
};

// 초기 로딩 시 위치 잡기
onMounted(async () => {
  await nextTick();
  // 초기 활성화된 탭의 인덱스를 찾아서 배경 이동
  const activeIndex = tabs.value.findIndex((tab) => tab.value === currentTab.value);
  moveHoriz(activeIndex !== -1 ? activeIndex : 0);
});

const emit = defineEmits(['close']);
const isOpen = ref(false);

// 닫기 로직
const handleClose = () => {
  //먼저 클래스를 제거해서 퇴장 애니메이션 실행
  isOpen.value = false;

  setTimeout(() => {
    emit('close');
  }, 300);
};

onMounted(() => {
  document.body.style.overflow = 'hidden';

  setTimeout(() => {
    isOpen.value = true;
  }, 10);
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>
<style scoped lang="scss">
.segment-wrap {
  margin-top: 1rem;
  .segment-control {
    border-radius: $size-s;
    background: $gray10;
    .segment-btn {
      width: 50%;
    }
    .horiz {
      border-radius: $size-s;
    }
  }
}
.card-con {
  display: none;
  &.open {
    display: block;
  }
  text-align: center;
  .txt-wrap {
    padding: 2rem 0 1rem;
    .sub-txt {
      font-size: $font-size-psmall;
      color: $color-gray-200;
      line-height: 130%;
    }
  }
  .before-regist {
    .card-add-btn {
      width: 252px;
      aspect-ratio: 9 / 5;
      border-radius: $size-s;
      border: 1px dotted $color-gray-60;
      background: $gray10;
    }
  }
  .after-regist {
    position: relative;
    .badge-pst {
      position: absolute;
      left: 0;
      top: 0.75rem;
    }
    .card-info-wrap {
      padding: 2.5rem 0 1.5rem;

      .card-name {
        font-weight: 500;
        margin: 0.25rem 0;
      }
      .card-num {
        font-size: $font-size-psmall;
        color: $color-gray-200;
      }
    }
    .l-btn {
      text-decoration: none;
    }
    .badge3 {
      font-size: $font-size-xs;
    }
  }
}
</style>
